import Routes from "routes";
import ThemeCustomization from "themes";
import RTLLayout from "components/RTLLayout";
import ScrollTop from "components/ScrollTop";
import Snackbar from "components/@extended/Snackbar";
import Notistack from "components/third-party/Notistack";
import { JWTProvider as AuthProvider } from "contexts/JWTContext";
import { useContext, useEffect } from "react";
import { ConfigContext } from "contexts/ConfigContext";
import DownloadModal from "components/reusables/DownloadModal";
import { useDispatch, useSelector } from "store";
import { fetchData } from "store/reducers/dataSlice";
import { fetchHeaderData } from "store/reducers/layoutSlice";
import { useLocation } from "react-router-dom";
import { Constants } from "services/keyConstants";
import { getItem, setItem } from "services/utils";

const MAX_HISTORY = 10;

const App = () => {
  const { isDownloading } = useContext(ConfigContext);
  const dispatch = useDispatch();
  const masterDocData = useSelector((state) => state.data);
  const headerData = useSelector((state) => state?.layout?.header?.data);

  const location = useLocation();

  // Utility: Check empty object
  const isEmpty = (obj) =>
    obj === null ||
    obj === undefined ||
    (typeof obj === "object" && Object.keys(obj).length === 0);

  // Initial fetch
  useEffect(() => {
    if (
      !masterDocData?.masterData ||
      Object.keys(masterDocData?.masterData || {}).length === 0
    ) {
      dispatch(fetchData());
    }

    if (isEmpty(headerData)) {
      dispatch(fetchHeaderData());
    }
  }, [dispatch]);

  useEffect(() => {
    const currentPath = location.pathname + location.search + location.hash;
    let historyStack = getItem(Constants.HISTORY_DATA) || [];

    // Remove any older occurrence of the current path
    historyStack = historyStack?.filter(path => path !== currentPath);

    // Add the current path to the end
    historyStack.push(currentPath);

    // Limit to last MAX_HISTORY entries
    if (historyStack.length > MAX_HISTORY) {
      historyStack.shift();
    }

    setItem(Constants.HISTORY_DATA, historyStack);
  }, [location]);

  return (
    <ThemeCustomization>
      <RTLLayout>
        <ScrollTop>
          <AuthProvider>
            <>
              <Notistack>
                <DownloadModal isOpen={isDownloading} />
                <Routes />
                <Snackbar />
              </Notistack>
            </>
          </AuthProvider>
        </ScrollTop>
      </RTLLayout>
    </ThemeCustomization>
  );
};

export default App;
